import React from 'react';

function OverwriteReportConfirmation({ reportName, onConfirm, onCancel }) {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Report Already Exists</h2>
        <p>
          A report named <strong>"{reportName}"</strong> already exists in this workspace.
        </p>
        <p>
          Do you want to overwrite the existing report?
        </p>
        <div className="modal-actions">
          <button 
            onClick={onCancel}
            className="btn-secondary"
          >
            Cancel
          </button>
          <button 
            onClick={onConfirm}
            className="btn-danger"
          >
            Overwrite Report
          </button>
        </div>
      </div>
    </div>
  );
}

export default OverwriteReportConfirmation;
